import { render, staticRenderFns } from "./addon.vue?vue&type=template&id=57f5c703&"
import script from "./addon.vue?vue&type=script&lang=js&"
export * from "./addon.vue?vue&type=script&lang=js&"
import style0 from "./addon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DatePicker: require('/home/runner/work/myody_front/myody_front/components/date/DatePicker.vue').default,FormItem: require('/home/runner/work/myody_front/myody_front/components/form/FormItem.vue').default,Form: require('/home/runner/work/myody_front/myody_front/components/form/Form.vue').default,GoodsOdgList: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsOdgList.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default,Col: require('/home/runner/work/myody_front/myody_front/components/col/Col.vue').default,Row: require('/home/runner/work/myody_front/myody_front/components/row/Row.vue').default})
